// Main hook
export { useRealtime } from './use-realtime'

// Types
export type {
  ConnectionState,
  EventHandler,
  EventHandlers,
  MessageHandler,
  RealtimeConfig,
  RealtimeHookReturn,
  RouteContext,
} from './types'

// Utilities
export {
  createEventHandlers,
  processWebSocketMessage,
  updateFileAndFolderQueries,
} from './event-handlers'
export {
  destroyGlobalWebSocketManager,
  getGlobalWebSocketManager,
  WebSocketManager,
} from './websocket-manager'

/**
 * Utility function to trigger authentication change event
 * Call this after successful login to immediately trigger WebSocket connection
 */
export const triggerAuthChange = () => {
  console.log('🚀 Triggering auth change event for immediate WebSocket connection...')
  window.dispatchEvent(new CustomEvent('auth-changed'))
}
